import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericToasterService } from 'src/app/core/services/generic-toaster.service';
import { BusquedaEncuesta } from '../model/BusquedaEncuesta';
import { environment } from 'src/environments/environment';
import { EncuestaGuardar, EncuestaView } from '../model/Encuesta';

@Injectable({
  providedIn: 'root'
})
export class EncuestaService {

  constructor(
    private httpClient: HttpClient,
    private genericToasterService: GenericToasterService) { }


  RecuperarEncuesta(parametros: BusquedaEncuesta): Promise<EncuestaView> {
    return new Promise((resolve) => {
      this.httpClient.post<EncuestaView>(`${environment.apiUrl}/Encuesta/RecuperarEncuesta`, parametros).subscribe({
        next: (data: EncuestaView) => { resolve(data); },
        error: (err) => { this.genericToasterService.pushError("ERROR_APLICACION"); }
      });
    });
  }

  GuardarRespuestaEncuesta(parametros: EncuestaGuardar): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.post<any>(`${environment.apiUrl}/Encuesta/GuardarRespuestaEncuesta`, parametros).subscribe({
        next: (data: any) => { resolve(data); },
        error: (err) => { this.genericToasterService.pushError("ERROR_APLICACION"); }
      });
    });
  }
}
